<template>
  <section id="dashboard-news-portal">
    <b-row class="match-height">
      <b-col
        xl="4"
        md="6"
      >
        <news-portal-medal :data="userData" />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <!-- <news-portal-statistics
          :data="data.statisticsItems"
        /> -->
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="4">
        <b-row class="match-height">
          <!-- Bar Chart - Orders -->
          <!-- <b-col
            lg="6"
            md="3"
            cols="6"
          >
            <news-portal-order-chart :data="data.statisticsOrder" />
          </b-col> -->
          <!--/ Bar Chart - Orders -->
          <!-- <b-col
            lg="6"
            md="3"
            cols="6"
          >
            <news-portal-profit-chart :data="data.statisticsProfit" />
          </b-col>
          <b-col
            lg="12"
            md="6"
          >
            <news-portal-earnings-chart :data="data.earningsChart" />
          </b-col> -->
        </b-row>
      </b-col>

      <!-- Revenue Report Card -->
      <!-- <b-col lg="8">
        <news-portal-revenue-report :data="data.revenue" />
      </b-col> -->
      <!--/ Revenue Report Card -->
    </b-row>

    <b-row class="match-height">
      <!-- Company Table Card -->
      <!-- <b-col lg="8">
        <news-portal-company-table :table-data="data.companyTable" />
      </b-col> -->
      <!--/ Company Table Card -->

      <!-- Developer Meetup Card -->
      <!-- <b-col
        lg="4"
        md="6"
      >
        <news-portal-meetup :data="data.meetup" />
      </b-col> -->
      <!--/ Developer Meetup Card -->

      <!-- Browser States Card -->
      <!-- <b-col
        lg="4"
        md="6"
      >
        <news-portal-browser-states />
      </b-col> -->
      <!--/ Browser States Card -->

      <!-- Goal Overview Card -->
      <!-- <b-col
        lg="4"
        md="6"
      >
        <news-portal-goal-overview :data="data.goalOverview" />
      </b-col> -->
      <!--/ Goal Overview Card -->

      <!-- Transaction Card -->
      <!-- <b-col
        lg="4"
        md="6"
      >
        <news-portal-transactions :data="data.transactionData" />
      </b-col> -->
      <!--/ Transaction Card -->

      <!-- <AvMedia
        :media="mediaObject"
        type="vbar"
      /> -->
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapState } from 'vuex'
import NewsPortalMedal from './NewsPortalMedal.vue'
// import NewsPortalStatistics from './NewsPortalStatistics.vue'
// import NewsPortalRevenueReport from './NewsPortalRevenueReport.vue'
// import NewsPortalOrderChart from './NewsPortalOrderChart.vue'
// import NewsPortalProfitChart from './NewsPortalProfitChart.vue'
// import NewsPortalEarningsChart from './NewsPortalEarningsChart.vue'
// import NewsPortalCompanyTable from './NewsPortalCompanyTable.vue'
// import NewsPortalMeetup from './NewsPortalMeetup.vue'
// import NewsPortalBrowserStates from './NewsPortalBrowserStates.vue'
// import NewsPortalGoalOverview from './NewsPortalGoalOverview.vue'
// import NewsPortalTransactions from './NewsPortalTransactions.vue'

export default {
  components: {
    BRow,
    BCol,
    NewsPortalMedal,
    // NewsPortalStatistics,
    // NewsPortalRevenueReport,
    // NewsPortalOrderChart,
    // NewsPortalProfitChart,
    // NewsPortalEarningsChart,
    // NewsPortalCompanyTable,
    // NewsPortalMeetup,
    // NewsPortalBrowserStates,
    // NewsPortalGoalOverview,
    // NewsPortalTransactions,
  },
  data() {
    return {
      data: {
        congratulations: {
          name: 'Guest',
          saleToday: '1024',
        },
      },
    }
  },
  computed: {
    ...mapState({
      loggedIn: state => state.auth.loggedIn,
      userData: state => state.auth.user,
    }),
  },
  created() {
  },
}
</script>

<style lang="scss">
// @import '@core/scss/vue/pages/dashboard-ecommerce.scss';
// @import '@core/scss/vue/libs/chart-apex.scss';
</style>
